import React from 'react';
import {Router, Routes, Route, Outlet, Link } from 'react-router-dom'

import Uganda from './uganda';
import Uganda_baby1_subjects from './uganda_baby1_subjects';
import TopNavbar from '../../components/TopNavbar';
import International_countries from '../international_countries';

const Uganda_baby1 = ( ) => {
 
  return (
    <>
    <TopNavbar />
    <Uganda />
    <International_countries />
  <Uganda_baby1_subjects />  
  
     <Outlet />
   

</>
  );
}

export default Uganda_baby1;

